export type QuoteStatus = 'Draft' | 'Sent' | 'Accepted' | 'Rejected' | 'Expired';

export interface QuoteItem {
  id: string;
  description: string;
  category: string;
  qty: number;
  unit: string;
  unitPrice: number;
  total: number;
}

export interface Quote {
  id: string;
  leadId: string;
  leadName: string;
  leadEmail: string;
  leadPhone: string;
  leadService: string;
  destination: string;
  travelDate: string;
  pax: number;
  title: string;
  items: QuoteItem[];
  subtotal: number;
  discountType: 'percent' | 'fixed';
  discountValue: number;
  discountAmount: number;
  taxRate: number;
  taxAmount: number;
  totalAmount: number;
  currency: string;
  validUntil: string;
  status: QuoteStatus;
  notes: string;
  terms: string;
  agent: string;
  agentAvatar: string;
  createdAt: string;
  sentAt: string | null;
  respondedAt: string | null;
  version: number;
}

export const quotesData: Quote[] = [];

export const agencyDetails = {
  name: 'Horizon Travel & Tourism',
  address: 'Office 1204, Al Moosa Tower 2, Sheikh Zayed Road, Dubai, UAE',
  phone: '+971 4 330 9900',
  email: 'quotes@horizontravel.ae',
  website: 'www.horizontravel.ae',
  trn: 'TRN 100487321200003',
  logo: 'HT',
  brandColor: '#D97706',
};
